import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import Home from "./pages/Home";
import Signin from "./pages/Signin";
import Signup from "./pages/Signup";
import BotDesk from "./pages/BotDesk";
import EmailVerification from "./pages/EmailVerification";
import ForgotPasswordOtp from "./pages/ForgotPasswordOtp";
import Office from "./pages/Office";
import Admin from "./pages/Admin";
import Desk from "./pages/Desk";
import OfficerDesk from "./pages/OfficerDesk";
import PrivateRoute from "./utils/PrivateRoute";
import AdminDashboard from "./components/adminDashboard";
import AdminDesk from "./pages/AdminDesk";
import OfficerSignup from "./pages/OfficerSignup";
import FAQDesk from "./pages/FAQDesk";
import LoginLayout from "./layouts/LoginLayout";

// main component of app
// default ui component for home page
function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <MainLayout>
              <Home />
            </MainLayout>
          }
        />
        <Route
          path="/login"
          element={
            <MainLayout>
              <Signin />
            </MainLayout>
          }
        />
        {/* <Route
          path="/officerLogin"
          element={
            <LoginLayout>
              <Office />
            </LoginLayout>
          }
        />
        <Route
          path="/adminLogin"
          element={
            <LoginLayout>
              <Admin />
            </LoginLayout>
          }
        /> */}
        <Route
          path="/register"
          element={
            <MainLayout>
              <Signup />
            </MainLayout>
          }
        />
        <Route
          path="/registerOfficer"
          element={
            <MainLayout>
              <OfficerSignup />
            </MainLayout>
          }
        />
        <Route
          path="/emailVerification"
          element={
            <MainLayout>
              <EmailVerification />
            </MainLayout>
          }
        />
        <Route
          path="/forgotPassword"
          element={
            <MainLayout>
              <ForgotPasswordOtp />
            </MainLayout>
          }
        />

        {/* <Route path="/desk" element={<Desk />} />
        <Route path="/botDesk" element={<BotDesk />} />
        <Route path="/officerDesk" element={<OfficerDesk />} /> */}
        <Route
          path="/desk"
          element={
            <PrivateRoute>
              <Desk />
            </PrivateRoute>
          }
        />
        <Route
          path="/botDesk"
          element={
            <MainLayout hideFooter>
              <BotDesk />
            </MainLayout>
          }
        />
        <Route
          path="/faq"
          element={
            <MainLayout hideFooter>
              <FAQDesk />
            </MainLayout>
          }
        />
        <Route
          path="/officerDesk"
          element={
            <PrivateRoute>
              <OfficerDesk />
            </PrivateRoute>
          }
        />
        <Route
          path="/adminDesk"
          element={
            <PrivateRoute>
              <AdminDesk />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
